import { MultiSelect } from "react-multi-select-component";
import { PaginationControls } from "../../../../hooks/customHook/paginationHook/usePagination";
import DataTable from "react-data-table-component";
import { customStyles } from "../../../../assets/table-style";
import { useServerPagination } from "../../../../hooks/customHook/paginationHook/useServerPagination";
import BASE_URL from "../../../../assets/global/url";
import { useEffect, useContext, useState, useRef } from "react";
import { RefreshContext } from "./NewInvoice";
import format from "date-fns/format";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

import FilterStore from "../../../../hooks/customHook/FilterStore";
import { formatCurrency, parseNumber } from "../../../../utils/numberFormatter";
import { NoTranslate } from "../../../../helper/prevent_translate_browser";
import { useServerSort } from "../../../../hooks/customHook/sortingHook/useTableSort";
import { useBulkSelection } from "../../../../hooks/customHook/useBulkSelection";
import { runBulkApproval } from "../../../../utils/bulkApproval";
import BulkActionBar from "../../../../components/BulkActionBar";

const PendingStatusTab = () => {
  const navigate = useNavigate();
  const {
    selectedCutOff,
    currencyId,
    fetchCutOff,
    fetchAllPendingCount,
    userLoggedID,
    authrztn,
    clearFilterSignal,
  } = useContext(RefreshContext);
  /// PARA ITO SA FILTER RETENTION
  // START
  // 1. Initialize state from the store
  const [selectedCustomer, setSelectedCustomer] = useState(() =>
    FilterStore.getSelected(),
  );

  // 2. Save to store whenever the selection changes
  useEffect(() => {
    FilterStore.saveSelected(selectedCustomer);
  }, [selectedCustomer]);
  const [customerList, setCustomerList] = useState([]);
  const [customerSearchValue, setCustomerSearchValue] = useState("");

  // For search filter
  const [searchTerm, setSearchTerm] = useState(() =>
    FilterStore.NIgetSearch("invoice_pending"),
  );
  useEffect(() => {
    FilterStore.NIsaveSearch(searchTerm, "invoice_pending");
  }, [searchTerm]);

  // Debounced version of searchTerm — this is what actually triggers API calls.
  // searchTerm updates immediately (for the input display); debouncedSearchTerm
  // waits 600 ms after the user stops typing before firing the effect → fetch.
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  ////END
  const [filterColumn, setFilterColumn] = useState(() =>
    FilterStore.getFilterColumn(),
  );

  // ADDED useEffect to persist it:
  useEffect(() => {
    FilterStore.saveFilterColumn(filterColumn);
    // ADDED: reset to "all" on unmount so when user navigates away and comes back,
    // no column is pre-checked.
    return () => {
      FilterStore.saveFilterColumn("all");
    };
  }, [filterColumn]);
  const debounceTimer = useRef();
  const pageRestored = useRef(false);

  // Reset all local filters when parent fires Clear Filter
  useEffect(() => {
    if (!clearFilterSignal) return; // skip on initial mount (signal === 0)
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setSelectedCustomer([]);
    setFilterColumn("all");
    FilterStore.NIsaveSearch("", "invoice_pending");
    FilterStore.saveSelected([]);
    FilterStore.saveFilterColumn("all");
  }, [clearFilterSignal]);

  // Pending always shows ALL pending invoices — the date range picker is
  // hidden on this tab, so never send a date restriction (even if the
  // Approved tab saved one in FilterStore). Backend skips the invoice_date
  // filter when startDate/endDate are null.
  const getPendingDateRange = () => ({ startDate: null, endDate: null });

  // For data table
  const pendingSalesInvoicePagination = useServerPagination(
    "about:blank",
    FilterStore.NIgetPerPage("invoice_pending"),
  );

  // No initial sortBy: the backend default (latest first) isn't a visible
  // column, so every header starts neutral until the user picks one
  const sort = useServerSort(pendingSalesInvoicePagination);

  // Bulk approve/reject — approvers only
  const canBulkApprove = authrztn.includes("Invoices-Approve");
  const bulk = useBulkSelection(pendingSalesInvoicePagination.data);

  const handleBulkAction = (action) =>
    runBulkApproval({
      action,
      rows: bulk.selectedRows,
      url: `${BASE_URL}/invoice/${action === "approve" ? "bulk-approved" : "bulk-rejected"}`,
      userLoggedID,
      getId: (row) => row.sales_invoice_id,
      getAmount: (row) => row.total_amount,
      getCurrencyName: (row) => row.currency?.currency_name,
      setIsProcessing: bulk.setIsProcessing,
      onDone: () => {
        fetchSalesInvoice();
        fetchCutOff();
        fetchAllPendingCount();
      },
    });

  // For customer search filter
  const getCustomers = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/invoice/getCustomersDataBySearch`,
        {
          params: {
            customerSearchValue,
          },
        },
      );

      if (res.status === 200) {
        setCustomerList(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Filter the data table based on selected customer
  const handleCustomerChange = (selectedOption) => {
    const isSelectAll = selectedOption.length === customerOptions.length;

    if (isSelectAll) {
      // Select All — show all data with base URL
      pendingSalesInvoicePagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData`,
      );
      pendingSalesInvoicePagination.updateParams({
        ...getPendingDateRange(selectedCutOff),
        status: "Pending",
        currencyId,
      });
    } else if (selectedOption.length > 0) {
      // Some selected — filter by them
      pendingSalesInvoicePagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData/customer-filter`,
      );
      pendingSalesInvoicePagination.updateParams({
        ...getPendingDateRange(selectedCutOff),
        status: "Pending",
        currencyId,
        selectedCustomer: selectedOption,
      });
    } else {
      // None selected — hide all data
      pendingSalesInvoicePagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData/customer-filter`,
      );
      pendingSalesInvoicePagination.updateParams({
        ...getPendingDateRange(selectedCutOff),
        status: "Pending",
        currencyId,
        selectedCustomer: [],
      });
    }
    // END CHANGED

    setSelectedCustomer(selectedOption);
    setSearchTerm("");
  };

  // Handle invoice deletion
  const handleDeleteInvoice = async (invoiceId, invoice_date, rowData) => {
    swal({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(
            `${BASE_URL}/invoice/deleteInvoice/${invoiceId}/${invoice_date}`,
            {
              data: { userLoggedID, rowData },
            },
          );
          if (response.status === 200) {
            swal({
              title: "Invoice Deleted Successfully!",
              text: "The invoice has been successfully deleted.",
              icon: "success",
              button: "OK",
            }).then(() => {
              fetchCutOff();
            });
          } else if (response.status === 203) {
            const { transactionNumber, moduleType } = response.data;
            let moduleFrom;
            if (moduleType === "Local-Bulk-Collection") {
              moduleFrom = "Local Collection";
            } else {
              moduleFrom = "Overseas Collection";
            }
            const title = document.createElement("div");
            const text = document.createElement("div");
            const swalInfo = document.createElement("div");

            title.innerHTML = `<div style="font-size: 1.5rem; font-weight: bold;">Deletion Prohibited!</div>`;
            text.innerHTML = `<div style="text-align: center; margin-top: 10px;">
                                Delete first the invoice in module <strong>${moduleFrom}</strong> with 
                                Transaction Number: <strong>${transactionNumber}</strong>
                              </div>`;

            swalInfo.append(title);
            swalInfo.append(text);
            swal({
              icon: "error",
              content: swalInfo,
            });
          } else if (response.status === 202) {
            const { invoiceDate, CutoffName } = response.data;
            swal({
              title: "Delete Prohibited!",
              text: `Invoice cannot be deleted as its invoice date (${invoiceDate}) falls within the posted cutoff period named "${CutoffName}".`,
              icon: "warning",
              button: "OK",
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact our support team for assistance.",
            });
          }
        } catch (error) {
          if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            console.log(error);
            swal({
              icon: "error",
              title: "Error",
              text: "An error occurred while deleting the invoice.",
            });
          }
        }
      }
    });
  };

  // Handle data table row click
  const handleViewInvoice = (row) => {
    if (row.client_transaction_id?.startsWith("ROT-S")) {
      navigate(`/sales/transaction-invoice-update/${row.sales_invoice_id}`);
    } else {
      navigate(`/sales/invoice-update/${row.sales_invoice_id}?page=1`);
    }
  };

  // Handle search filter change
  const handleFilterColumnSelect = (column) => {
    // ADDED: if the same column is clicked again, uncheck it by resetting to "all"
    const newColumn = filterColumn === column ? "all" : column;
    setFilterColumn(newColumn);
    // setSearchTerm("");

    if (newColumn === "all") {
      pendingSalesInvoicePagination.updateApiUrl(
        BASE_URL + "/invoice/getSalesData",
      );
      pendingSalesInvoicePagination.updateParams({
        ...getPendingDateRange(selectedCutOff),
        filterColumn: "all",
        searchTerm: "",
        status: "Pending",
        currencyId,
        selectedCustomer,
      });
    }
    // END ADDED
  };

  // Handle search change
  const handleSearch = (e) => {
    let input = e.target.value;

    const raw = String(input).replace(/,/g, ""); // Remove commas
    const [intPart, decimalPart] = raw.split("."); // Split into integer and decimal part
    const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to integer part
    const formatted =
      decimalPart !== undefined ? `${withCommas}.${decimalPart}` : withCommas; // Join back decimal part if it exists

    if (debounceTimer.current) clearTimeout(debounceTimer.current); // Clear previous debounce timer

    // When search is cleared, go back to the full pending list.
    // Pending never touches the shared selectedCutOff — that date range
    // belongs to the Approved tab.
    if (!input.trim()) {
      setDebouncedSearchTerm(""); // immediate reset, triggers fetchSalesInvoice with empty term
      pendingSalesInvoicePagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData`,
      );
      pendingSalesInvoicePagination.updateParams({
        ...getPendingDateRange(),
        filterColumn: "all",
        searchTerm: "",
        status: "Pending",
        currencyId,
        selectedCustomer,
      });
      setSearchTerm("");
      return;
    }

    // Feature 1: search without date restriction — pass null so backend ignores invoice_date filter
    debounceTimer.current = setTimeout(() => {
      setDebouncedSearchTerm(input); // triggers the useEffect → fetchSalesInvoice
    }, 600);

    // To apply comma if match with total amount
    const isMatchingTotalAmount = pendingSalesInvoicePagination.data.some(
      (item) => String(item.total_amount).includes(raw),
    );

    setSearchTerm(isMatchingTotalAmount ? formatted : raw);
  };

  // Handle sales invoice data fetching for table
  const fetchSalesInvoice = () => {
    ////PARA ITO SA FILTER RENTENTION
    ////START
    // 1. Determine the correct URL based on saved state
    let apiUrl = BASE_URL + "/invoice/getSalesData";

    if (selectedCustomer && selectedCustomer.length > 0) {
      apiUrl = `${BASE_URL}/invoice/getSalesData/customer-filter`;
    } else if (debouncedSearchTerm) {
      apiUrl = `${BASE_URL}/invoice/getSalesData/search-filter`;
    }

    // 2. Update the pagination hook with the correct URL and parameters
    pendingSalesInvoicePagination.updateApiUrl(apiUrl);
    ////END

    // FIX: when a search term is active, do NOT send date restrictions so
    // the backend searches across ALL periods — not just the current cutoff.
    const isSearching = !!(
      debouncedSearchTerm && debouncedSearchTerm.trim() !== ""
    );

    pendingSalesInvoicePagination.updateParams({
      ...(isSearching
        ? { startDate: null, endDate: null }
        : getPendingDateRange(selectedCutOff)),
      filterColumn,
      searchTerm: debouncedSearchTerm,
      status: "Pending",
      currencyId,
      selectedCustomer,
    });
  };

  // Options for customer filter
  const customerOptions = customerList.map((item) => ({
    value: item.customer_id,
    label:
      item.company_name ||
      [item.first_name, item.last_name].filter(Boolean).join(" "),
  }));

  // Options for search filter
  const searchFilter = [
    { value: "client_transaction_id", label: "Transaction ID" },
    { value: "destination", label: "Destination" },
    { value: "invoice_date", label: "Invoice Date" },
    { value: "due_date", label: "Due Date" },
    { value: "dr_number", label: "DR Number" },
    { value: "po_number", label: "PO Number" },
    { value: "total_amount", label: "Total Amount" },
    { value: "product_name", label: "Product Name" },
    { value: "product_code", label: "Product Code" },
    { value: "customer", label: "Customer" },
  ];

  // For data table columns
  const columns = [
    {
      name: "Transaction ID",
      selector: (row) => row.client_transaction_id,
      sortField: "client_transaction_id",
      cell: (row) => (
        <div className="text-nowrap text-center">
          <NoTranslate>{row.client_transaction_id}</NoTranslate>
        </div>
      ),
      conditionalCellStyles: [
        {
          when: (row) =>
            row.client_transaction_id &&
            row.client_transaction_id.startsWith("ROT-"),
          style: {
            color: "#16c03d",
          },
        },
      ],
    },
    {
      name: "Destination",
      selector: (row) => row.destination,
      sortField: "destination",
      cell: (row) => <div className="text-center">{row.destination}</div>,
    },
    {
      name: "Container Number",
      selector: (row) => row.container_number,
      sortField: "container_number",
      cell: (row) => <div>{row.container_number || "n/a"}</div>,
    },
    {
      name: "Pier",
      selector: (row) => row.pier,
      sortField: "pier",
      cell: (row) => <div>{row.pier || "n/a"}</div>,
    },
    {
      name: "Customer",
      sortField: "customer",
      // Company name first, else first name + last name (last name only if available)
      selector: (row) =>
        row.customer.company_name ||
        [row.customer.first_name, row.customer.last_name]
          .filter(Boolean)
          .join(" "),
    },
    {
      name: "Invoice Date",
      sortField: "invoice_date",
      selector: (row) => format(row.invoice_date, "MMM/dd/yyyy"),
    },
    {
      name: "Date Approve",
      sortField: "date_approved",
      selector: (row) =>
        row.date_approved
          ? format(row.date_approved, "MMM/dd/yyyy hh:mm a")
          : "n/a",
    },
    {
      name: "Due Date",
      sortField: "due_date",
      selector: (row) => row.daysDifference,
    },
    {
      name: "DR Number",
      sortField: "dr_number",
      selector: (row) => row.dr_number || "n/a",
    },
    {
      name: "PO Number",
      sortField: "po_number",
      selector: (row) => row.po_number || "n/a",
    },

    // {
    //   name: "Currency",
    //   selector: (row) => row.currency.currency_name,
    // },
    // {
    //   name: "Currency Rate",
    //   selector: (row) => row.rate,
    // },
    {
      name: "Total Amount",
      selector: (row) => row.total_amount,
      sortField: "total_amount",
      cell: (row) => {
        const isROT =
          row.client_transaction_id &&
          row.client_transaction_id.startsWith("ROT-");
        const amount = parseNumber(row.total_amount) || 0;

        if (isROT) {
          const isNegative = amount < 0;
          const isPositive = amount > 0;

          return (
            <div
              className="text-center"
              style={{
                color: isNegative ? "red" : isPositive ? "green" : "inherit",
                fontWeight: "bold",
              }}
            >
              {isPositive ? "+" : ""}
              {formatCurrency(amount, row.currency?.currency_name)}
            </div>
          );
        }

        return (
          <div className="text-center">
            <NoTranslate>
              {formatCurrency(amount, row.currency?.currency_name)}
            </NoTranslate>
          </div>
        );
      },
    },
    {
      name: "Status",
      sortField: "status",
      selector: (row) => row.status,
      cell: (row) => {
        let color;
        switch (row.status) {
          case "Pending":
            color = "#FFA500";
            break;
          case "Approved":
            color = "#3B9F3F";
            break;
          case "Rejected":
            color = "#FF0000";
            break;
          default:
            color = "initial";
        }
        return (
          <div
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              color: color,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            {row.status}
          </div>
        );
      },
    },
  ];

  // Include invoice delete button if the user is authorized
  if (authrztn.includes("Invoices-Delete")) {
    columns.push({
      name: "Action",
      selector: (row) => {
        const status = row.status;
        const isReturned = status === "Returned";
        const isPending = status === "Pending";
        return (
          <div className="d-flex align-items-center gap-2 p-3">
            <button
              type="button"
              className="border-0 bg-transparent"
              disabled={isReturned}
            >
              <i
                className="fas fa-trash"
                style={{
                  cursor: `${isReturned ? "not-allowed" : "pointer"}`,
                  color: "red",
                  fontSize: "1.5rem",
                  opacity: `${isReturned ? "0.5" : "1"}`,
                }}
                onClick={() => {
                  handleDeleteInvoice(
                    row.sales_invoice_id,
                    row.invoice_date,
                    row,
                  );
                }}
              ></i>
            </button>
          </div>
        );
      },
    });
  }

  ///PARA ITO SA FILTER RETENTION NG PAGE
  //START
  // Save gate — stays closed until after mount restore settles,
  // so the hook's internal reset-to-1 from updateParams doesn't overwrite the saved page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pendingSalesInvoicePagination.currentPage) {
      FilterStore.NIsavePage(
        pendingSalesInvoicePagination.currentPage,
        "invoice_pending",
      );
    }
  }, [pendingSalesInvoicePagination.currentPage]);

  useEffect(() => {
    if (pendingSalesInvoicePagination.itemsPerPage) {
      FilterStore.NIsavePerPage(
        pendingSalesInvoicePagination.itemsPerPage,
        "invoice_pending",
      );
    }
  }, [pendingSalesInvoicePagination.itemsPerPage]);

  // Restore last viewed page on mount. setTimeout(600) defers until after
  // selectedCutOff → fetchSalesInvoice → updateParams → hook's reset-to-1 has settled,
  // then opens the save gate for user navigation.
  useEffect(() => {
    const savedPage = FilterStore.NIgetPage("invoice_pending");
    if (savedPage > 1) {
      setTimeout(() => {
        pendingSalesInvoicePagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 600);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 600);
    }
  }, []);
  //END

  useEffect(() => {
    fetchSalesInvoice();
  }, [selectedCutOff, currencyId, filterColumn, debouncedSearchTerm]); ///ADDED PART OF RETENTION

  useEffect(() => {
    getCustomers();
  }, [customerSearchValue]);

  return (
    <div className="container-fluid">
      <div className="row mb-3">
        <div className="col-sm-12 col-md-4">
          <span>Customer</span>
          <MultiSelect
            options={customerOptions}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            labelledBy="Select Customer"
            filterOptions={(options, filter) => {
              setCustomerSearchValue(filter);
              return options.filter(({ label }) =>
                label.toLowerCase().includes(filter.toLowerCase()),
              );
            }}
            debounceDuration={300}
            overrideStrings={{
              selectSomeItems: "Select Customer", // placeholder text
              search: "Search Customer",
            }}
          />
        </div>
      </div>
      <div className="w-100 mt-2">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
          <button
            type="button"
            className="btn btn-outline-secondary dropdown-toggle-split"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-sliders"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button
                className={`dropdown-item ${
                  filterColumn === "all" ? "active" : ""
                }`}
                onClick={() => handleFilterColumnSelect("all")}
              >
                All
              </button>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            {searchFilter.map(({ value, label }) => (
              <li key={value}>
                <button
                  className={`dropdown-item ${
                    filterColumn === value ? "active" : ""
                  }`}
                  onClick={() => handleFilterColumnSelect(value)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* data table */}
      <div className="w-100 mt-3">
        <div className="sales-invoice-data-table">
          {canBulkApprove && (
            <BulkActionBar
              selectedCount={bulk.selectedRows.length}
              isProcessing={bulk.isProcessing}
              onApprove={() => handleBulkAction("approve")}
              onReject={() => handleBulkAction("reject")}
            />
          )}
          <DataTable
            columns={sort.sortColumns(columns)}
            data={pendingSalesInvoicePagination.data}
            customStyles={customStyles}
            className="dataTable"
            onRowClicked={handleViewInvoice}
            {...(canBulkApprove && bulk.tableProps)}
            {...sort.sortProps}
          />
          <PaginationControls {...pendingSalesInvoicePagination} />
        </div>
      </div>
    </div>
  );
};

export default PendingStatusTab;
